export const GET_SEARCH_DETAILS = 'workQueue/GET_SEARCH_DETAILS';
export const SET_SEARCH_DETAILS = 'workQueue/SET_SEARCH_DETAILS';
export const SET_SELECTED_CUST = 'workQueue/SET_SELECTED_CUST';
export const SET_CLEAR_CUSTOMER = 'workQueue/SET_CLEAR_CUSTOMER';
export const SET_MASTER_DATA = 'workQueue/SET_MASTER_DATA';
export const SET_ACTIVE_TAB = 'workQueue/SET_ACTIVE_TAB';
export const SET_INVALID_EXPORT = 'workQueue/SET_INVALID_EXPORT';
export const SET_EXPORT_ERROR = 'workQueue/SET_EXPORT_ERROR';
export const RESET_EXPORT_ERROR = 'workQueue/RESET_EXPORT_ERROR';
export const LOAN_CLASS_EXIST = 'The NLS Loan Class already exists. Please add a unique value.';
export const LOAN_STATUS_NOT_EXIST = 'Loan Number or status code does not exist';
export const AGREEMENT_ALREADY_EXPORTED = 'This agreement has been previously exported to Nortridge.';
export const AGREEMENT_APPROVED_STATUS = 'The agreement does not have an approved status.';
export const MULTI_USE_LIMIT_ERROR = 'Multi-Use (US & CA) Regular Limit must be greater than $100.';
export const ICE_APP_ERROR = 'Application does not have an ICE App Id.';
export const ACM_NOT_FOUND = 'ACM record not found on agreement.';
export const USER_NOT_ACM = 'You are not listed as the ACM on the agreement.  Please verify that the ACM entry is correct.';
export const BUSINESS_PARTNER_NOT_FOUND_FOR_USER = 'BP_ID_NBR not found for user';
export const BUSINESS_PARTNER_NOT_FOUND_FOR_CUSTOMER = 'BP record not found for role';
export const NON_APPLICANT_INDIVIDUAL = 'Non Applicant Role must be an individual.';
export const ADDRESS_REQUIRED = 'Street/PO Box is required.';
export const CITY_REQUIRED = 'City is required.';
export const STATE_REQUIRED = 'State is required.';
export const ZIPCODE_REQUIRED = 'ZipCode is required.';
export const SM_NOT_FOUND = 'Sm_id_nbr not found for this customer.';
